/* istanbul ignore file */

import { css } from 'styled-components';

export const smallElevation = css`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
`;

export const mediumElevation = css`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
`;

export const largeElevation = css`
  box-shadow: 0px 8px 16px 0px rgba(30, 30, 41, 0.16);
`;
